import timur from "./assets/timur.svg";
import timurBg from "./assets/timur-bg.svg";
import belbix from "./assets/belbix.svg";
import belbixBg from "./assets/belbix-bg.svg";
import ksen from "./assets/ksen.svg";
import ksenBg from "./assets/ksen-bg.svg";
import dr from "./assets/dr.svg";
import drBg from "./assets/dr-bg.svg";
import god from "./assets/god.svg";
import godBg from "./assets/god-bg.svg";
import oleg from "./assets/oleg.svg";
import olegBg from "./assets/oleg-bg.svg";
import reptile from "./assets/reptile.svg";
// import reptileBg from "./assets/reptile-bg.svg";
import iam from "./assets/iam.svg";
import iamBg from "./assets/iam-bg.svg";
import water from "./assets/water.svg";
import waterBg from "./assets/water-bg.svg";
import bogd from "./assets/bogd.svg";
import bogdBg from "./assets/bogd-bg.svg";

export const staff = [
  {
    name: "Belbix",
    position: "Nomarch solidity dev",
    image: belbix,
    imageBg: belbixBg,
    contacts: [
      {
        type: "linkedin",
        link: "https://www.linkedin.com/in/belbix/",
      },
      {
        type: "twitter",
        link: "https://twitter.com/belbix",
      },
    ],
  },
  {
    name: "Kseniachezz",
    position: "Designer",
    image: ksen,
    imageBg: ksenBg,
    contacts: [
      {
        type: "facebook",
        link: "https://www.facebook.com/ksenia.chezz",
      },
    ],
  },
  {
    id: "DR",
    name: "DR. Tetu",
    position: "Business dev",
    image: dr,
    imageBg: drBg,
    contacts: [
      {
        type: "linkedin",
        link: "https://www.linkedin.com/in/godinmaking/",
      },
      {
        type: "twitter",
        link: "https://twitter.com/DogInMaking?t=aeCqai_80OZhINw64KQmzg&s=09",
      },
    ],
  },
  {
    name: "Constmalutin",
    position: "Nomarch front end dev",
    image: god,
    imageBg: godBg,
    contacts: [
      {
        type: "instagram",
        link: "https://www.instagram.com/const_malytin/",
      },
      {
        type: "github",
        link: "https://github.com/malytinKonstantin",
      },
    ],
  },
  {
    name: "Olegn",
    position: "Solidity dev",
    image: oleg,
    imageBg: olegBg,
    contacts: [
      {
        type: "github",
        link: "https://github.com/olegnat",
      },
    ],
  },
  {
    name: "Timuricio",
    position: "Art-Director",
    image: timur,
    imageBg: timurBg,
    contacts: [
      {
        type: "behance",
        link: "https://www.behance.net/timuricio",
      },
      {
        type: "twitter",
        link: "https://twitter.com/Timuricio_CG",
      },
    ],
  },
  {
    name: "Iamkosyak",
    position: "Dune/solidity dev",
    image: iam,
    imageBg: iamBg,
    contacts: [
      {
        type: "linkedin",
        link: "http://www.linkedin.com/in/iamkosyak",
      },
    ],
  },
  {
    name: "Waterfound",
    position: "Content writer",
    image: water,
    imageBg: waterBg,
    contacts: [
      {
        type: "github",
        link: "https://github.com/Waterfound",
      },
    ],
  },
  {
    name: "Bogdoslav",
    position: "Solidity dev",
    image: bogd,
    imageBg: bogdBg,
    contacts: [
      {
        type: "github",
        link: "https://github.com/bogdoslavik",
      },
    ],
  },
];
